<template>
  <div class="krs028">
    <div class="tb-list_ty2">
      <div class="tb-header">
        <div class="top clear">
          <div class="fl">
            <div class="tb_num">
              {{$i18nUtil.trans("message.ProjectMemberManage.001","과제 멤버 수")}} <b>{{ projectMemberCount }} </b>
            </div>
            <div class="check_result" v-if="isFilter">
              <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: searchKeyword, cnt: cogroupUserList.length})">
              </div>
              <button type="button" @click="searchReset">초기화</button>
            </div>
          </div>

          <div class="tb_sort fr">
            <button type="button" class="btn_link_add" @click="addMember">
              {{ $i18nUtil.trans("button.member.add.orgChart","조직도에서 멤버 추가") }}
            </button>
            <button
              type="button"
              class="btn_link_add"
              v-if="projectInfo.isInviteUse"
              @click="invitationMember"
            >
              {{ $i18nUtil.trans("button.member.add.external","외부협력사 멤버 초대") }}
            </button>
            <div class="dividing_line_ty2"></div>
            <div class="dropdown ty2 relative right">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on">{{
                    filter == "ALL_MEMBER"
                      ? $i18nUtil.trans("message.ProjectMemberManage.002.authorization","권한 전체")
                      : filter == "MEMBER"
                      ? $i18nUtil.trans("message.ProjectMemberManage.002.member","멤버")
                      : $i18nUtil.trans("message.ProjectMemberManage.002.manager","운영자")
                  }}</v-btn>
                </template>
                <div class="dropdown-list">
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: filter == 'ALL_MEMBER' }"
                        @click="filter = 'ALL_MEMBER'"
                      >
                        {{ $i18nUtil.trans("message.ProjectMemberManage.002.authorization","권한 전체") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: filter == 'MEMBER' }"
                        @click="filter = 'MEMBER'"
                      >
                        {{ $i18nUtil.trans("message.ProjectMemberManage.002.member","멤버") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: filter == 'MANAGER' }"
                        @click="filter = 'MANAGER'"
                      >
                        {{ $i18nUtil.trans("message.ProjectMemberManage.002.manager","운영자") }}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
          </div>
        </div>
        <div class="btm clear">
          <div class="fl">
            <span style="padding-top: 6px;">{{ $i18nUtil.trans("message.ProjectMemberManage.003","선택 멤버를") }} </span>
            <div class="dropdown ty2 relative" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : ''">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="disabled">{{ $i18nUtil.trans("message.ProjectMemberManage.004.modify","변경") }}</v-btn>
                </template>
                <div class="dropdown-list">
                  <div class="dropdown-list-item">
                    <div class="tit"><b>{{ $i18nUtil.trans("message.ProjectMemberManage.004.modify.authorization","권한 변경") }}</b></div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: gradeSetting == 'MEMBER' }"
                        @click="saveChanges('MEMBER')"
                      >
                        {{ $i18nUtil.trans("message.ProjectMemberManage.002.member","멤버") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: gradeSetting == 'MANAGER' }"
                        @click="saveChanges('MANAGER')"
                      >
                        {{ $i18nUtil.trans("message.ProjectMemberManage.002.manager","운영자") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit"><b>{{ $i18nUtil.trans("message.ProjectMemberManage.004.modify.status","상태 변경") }}</b></div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: gradeSetting == 'REJECT' }"
                        @click="saveChanges('REJECT')"
                      >
                        {{ $i18nUtil.trans("message.ProjectMemberManage.002.except","멤버 제외") }}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
          </div>

          <div class="tb_sort fr">
            <div class="dropdown ty2 relative">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="disabled">{{
                    searchType == "NAME"
                      ? $i18nUtil.trans("entity.user.name","이름")
                      : searchType == "ID"
                      ? $i18nUtil.trans("entity.user.userId","아이디")
                      : $i18nUtil.trans("entity.user.affiliation","소속")
                  }}</v-btn>
                </template>
                <div class="dropdown-list">
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'NAME' }"
                        @click="searchType = 'NAME'"
                      >
                        {{ $i18nUtil.trans("entity.user.name","이름") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'ID' }"
                        @click="searchType = 'ID'"
                      >
                        {{ $i18nUtil.trans("entity.user.userId","아이디") }}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'DEPT' }"
                        @click="searchType = 'DEPT'"
                      >
                        {{ $i18nUtil.trans("entity.user.affiliation","소속") }}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
            <form action="" onsubmit="return false;">
              <div class="search_ty1">
                <input
                  type="text"
                  maxlength="20"
                  class="ico_search"
                  @focus="$event.target.placeholder = ''"
                  @focusout="$event.target.placeholder = $i18nUtil.trans('message.placeholder.keyword','검색어 입력')"
                  :placeholder="$i18nUtil.trans('message.placeholder.keyword','검색어 입력')"
                  @input="searchInput"
                  :value="keyWord"
                  @keyup.enter="
                    handlerFilterMember(filter, searchType, keyWord, 1)
                  "
                />
                <button
                  type="reset"
                  class="input-txt-del"
                  @click="keyWord = ''"
                  v-if="keyWord != ''"
                >
                  삭제
                </button>
                <button
                  type="button"
                  class="btn_search"
                  @click="handlerFilterMember(filter, searchType, keyWord, 1)"
                >
                  검색
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- //tb-header -->

      <v-data-table
        v-model="checkUsers"
        :headers="headers"
        :items="cogroupUserList"
        :single-select="singleSelect"
        show-select
        :sort-by="'joinDate'"
        :sort-desc="true"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
        class="tb-contents"
      >
        <!-- <template v-slot:item.id="{ item }">
          <div class="ell-singleline">{{ item }}</div>
        </template> -->
        <template v-slot:item.userId="{ item }">
          <div class="ell-singleline">{{ item.userId }}</div>
        </template>
        <template v-slot:item.userName="{ item }">
          <div class="droplayer tooltipmember relative">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                  ><b>{{ item.userName }}</b></v-btn
                >
              </template>
              <div class="dropdown-list">
                <UserTooltip :userId="item.userId" />
              </div>
            </v-menu>
          </div>
        </template>
        <template v-slot:item.deptName="{ item }">
          <div class="ell-singleline">{{ item.deptName }}</div>
        </template>

        <template v-slot:item.jobPositionName="{ item }">
          <div class="ell-singleline">{{ item.jobPositionName }}</div>
        </template>

        <template v-slot:item.jobFunctionName="{ item }">
          <div class="ell-singleline">{{ item.jobFunctionName }}</div>
        </template>

        <template v-slot:item.expiretxt="{ item }">
          <button
            type="button"
            class="btn-primary-small"
            v-if="item.isExpire"
            @click="expireExtend(item.userId, item.userName)"
          >
            {{ $i18nUtil.trans("message.ProjectMemberManage.006","{days}일 연장", {days: item.expire}) }}
          </button>
        </template>
        <template v-slot:item.userGrade="{ item }">
          <div class="ell-singleline">
            {{ item.userGrade == "MANAGER" ? 
              $i18nUtil.trans("message.ProjectMemberManage.002.manager","운영자") 
              : $i18nUtil.trans("message.ProjectMemberManage.002.member","멤버") }}
          </div>
        </template>
        <template slot="no-data">
          <div class="nodata-txt-noicon">
            <v-alert :value="true">
              {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
            </v-alert>
          </div>
        </template>
      </v-data-table>

      <div class="pagination">
        <v-pagination
          v-model="page"
          circle
          :length="pageCount"
          :total-visible="7"
        ></v-pagination>
      </div>
    </div>
    <!-- //tb-list_ty1 -->
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import MultiOrg from "@/components/cowork/common/organization/org/MultiOrg";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import InvitationMembers from "./InvitationMembers";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import EventBus from "@/js/eventbus/eventBus";

export default {
  components: {
    UserTooltip,
  },
  data() {
    return {
      gradeSetting: "",
      isFilter: false,
      filter: "ALL_MEMBER",
      keyWord: "",
      searchKeyword: "",
      searchType: "NAME",
      // memberCount: 0,
      currentGrade: "",
      checkUsers: [],
      cogroupUserList: [],
      error: true,
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      singleSelect: false,
      headers: [
        { text: this.$i18nUtil.trans("entity.user.name","이름"), align: "center", value: "userName", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.userId","아이디"), value: "userId", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.affiliation","소속"), align: "center", value: "deptName", sortable: false },
        {
          text: this.$i18nUtil.trans("entity.user.jobPositionName","직위"),
          align: "center",
          value: "jobPositionName",
          sortable: false,
        },
        {
          text: this.$i18nUtil.trans("entity.user.jobFunctionName","직책"),
          align: "center",
          value: "jobFunctionName",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("entity.user.joinDate","가입일"), align: "center", value: "joinDate", sortable: false },
        {
          text: this.$i18nUtil.trans("message.ProjectMemberManage.005.member.accountExpiration","계정만료"),
          align: "center",
          value: "expiretxt",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("entity.user.permission","권한"), align: "center", value: "userGrade", sortable: false },
      ],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("project", ["projectMemberList"]), // 현재 멤버정보
    ...mapState("project", ["projectMemberCount"]), // 멤버의 수
    ...mapState("project", ["projectInfo"]), // 현재 정보
  },
  watch: {
    projectMemberList: function () {
      this.cogroupUserList = this.projectMemberList;
    },
    filter: function () {
      this.handlerFilterMember(
        this.filter,
        this.searchType,
        this.searchKeyword,
        null,
        0
      );
    },
  },
  created() {
    // this.createdList();
    EventBus.$off("updateCogroupUser");
    EventBus.$on("updateCogroupUser", (param) => {
      this.searchReset();
      this.checkUsers = [];
    });
  },
  methods: {
    ...mapActions("modals", ["showToast"]),
    ...mapMutations("project", ["setProjectMemberList"]),
    ...mapMutations("project", ["setProjectMemberCount"]),
    ...mapActions("modals", ["showModal"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    createdList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/cogroupUser/getCogroupUserList",
        method: "post",
        req: {
          groupId: this.info.groupId,
        },
      };
      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          obj.setProjectMemberList(res.result.data);
          obj.setProjectMemberCount(res.result.countuser);
          obj.cogroupUserList = res.result.data;
          // obj.memberCount = obj.projectMemberCount;
          obj.filter = "ALL_MEMBER";
          obj.checkUsers = [];
        })
        .catch((err) => {
          console.log(err);
          console.log("[그룹멤버 오류]");
        });
    },
    addMember() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.MultiOrg.001","조직도"),
        method: "post",
        width: "1050px",
        height: "800px",
        obj: this.$modal,
        //orgType: "SINGLE_USER",
        //orgType: "MULTI_USER",
        orgType: "MULTI_ORG",
        //orgType: "SINGLE_DEPT",
        //orgType: "MULTI_DEPT",
        //component: Organization,
        component: MultiOrg,
        url: "/api/org/getDeptList",
      };
      this.showModal(modalInfo);
    },
    selectedMember(data) {
      let obj = this;
      let type = data.orgType;
      let depts = data.depts;
      let users = data.users;
      if (depts.length > 0 || users.length > 0) {
        // if (depts.length > 0) {
        //   depts.forEach(function (item, index, arr) {
        //     params += item.label + ".";
        //   });
        // }
        if (users.length > 0) {
          let addCogroupUserList = [];
          users.forEach(function (item, index, arr) {
            //console.log("item:", item);
            let jsonData = {};
            jsonData.groupId = obj.info.groupId;
            jsonData.userId = item.userId;
            jsonData.userGrade = "MEMBER";
            jsonData.userKbn = "01";
            jsonData.sortNo = 1;
            addCogroupUserList.push(jsonData);
          });
          const reqData = {
            url: "/api/cogroup/cogroupUser/registCogroupUser",
            method: "post",
            obj: obj,
            req: {
              groupId: obj.info.groupId,
              addCogroupUserList: addCogroupUserList,
            },
          };
          obj
            .COWORK_REST_ACTION(reqData)
            .then((data) => {
              if (data.result) {
                obj.createdList();
                obj.countUser = data.result;
              }
            })
            .catch((err) => {
              console.log(err);
              console.log("[멤버추가 오류]");
              alert("[멤버추가 오류]");
            });
        }
      }
    },
    // 멤버 초대
    invitationMember() {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.InvitationMembers.000","멤버 초대"),
        width: "800px",
        height: "650px",
        obj: this.$modal,
        listType: this.listType,
        groupId: this.info.groupId,
        component: InvitationMembers,
      };
      this.showModal(modalInfo);
    },
    /* 초대 멤버  */
    getInvitationMemberlist(groupId) {
      let obj = this;
      let reqData = {};
      reqData.req = {
        groupId: groupId,
      };
      reqData.url = "/api/cogroup/cogroupUserManage/getCogroupUserManageList";
      reqData.method = "post";
      obj
        .COWORK_REST_ACTION(reqData)
        .then((res) => {
          console.log(res);
          this.invitationMemberList = res.result.data;
          this.invitationCountUser = res.result.count;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    saveChanges(type) {
      
      if (this.checkUsers.length == 0) {
        this.toastInfo.message = this.$i18nUtil.trans("message.ProjectMemberManage.007","멤버를 선택해주세요.");
        this.showToast(this.toastInfo);
        return;
      }
      // console.log(this.checkUsers);
      let checkUsers = this.checkUsers;
      if (type == "REJECT") {
        // 탈퇴
        const deleteUserList = [];

        for (let i = 0; i < checkUsers.length; i++) {
          const data = {
            userGrade: checkUsers[i].userGrade,
            userId: checkUsers[i].userId,
            userKbn: checkUsers[i].userKbn,
          };
          deleteUserList.push(data);
        }
        const modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.except.member","멤버 제외"),
          width: "400px",
          // height: "166px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("AB073", {
            userName: checkUsers[0].userName,
            userCnt: checkUsers.length - 1,
          }),
          button: this.$i18nUtil.trans("button.except","제외"),
          subButton: this.$i18nUtil.trans("button.cancel","취소"),
          deleteUserList: deleteUserList,
          userName: this.checkUsers[0].userName,
          dialogType: type,
          component: Dialog,
        };
        this.showModal(modalInfo);
      } else {
        const updateUserList = [];
        if (type == "MEMBER") {
          let memberCheck = true;
          const obj = this;
          checkUsers.forEach((item) => {
            if(item.userId == obj.projectInfo.project.regUserId) {
              const modalInfo = {
                title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                width: "400px",
                // height: "166px",
                obj: this.$modal,
                contents: this.$i18nUtil.trans("message.ProjectMemberManage.008","생성자는 멤버로 변경할 수 없습니다."),
                button: this.$i18nUtil.trans("button.confirm","확인"),
                component: Dialog,
              };
              obj.showModal(modalInfo);
              memberCheck = false;
            }
          })
          if(!memberCheck) {
            return;
          }
          // 멤버로 지정
          for (let i = 0; i < checkUsers.length; i++) {
            const data = {
              userGrade: "MEMBER",
              userId: checkUsers[i].userId,
              userKbn: checkUsers[i].userKbn,
              groupId: this.info.groupId,
              currentGrade: checkUsers[i].userGrade,
            };
            updateUserList.push(data);
          }

          let updateUserCount = 0;
          let projectManagerCount = 0;
          this.projectMemberList.forEach((value) => {
            if (value.userGrade == "MANAGER") {
              projectManagerCount += 1;
            }
          });
          checkUsers.forEach((value) => {
            if (value.userGrade == "MANAGER") {
              updateUserCount += 1;
            }
          });
          if (updateUserCount == projectManagerCount) {
            const modalInfo = {
              title: this.$i18nUtil.trans("title.dialog.notice","알림"),
              width: "400px",
              // height: "166px",
              obj: this.$modal,
              contents: this.$i18nUtil.trans("AB064"),
              button: this.$i18nUtil.trans("button.confirm","확인"),
              component: Dialog,
            };
            this.showModal(modalInfo);
            return;
          }
        } else if (type == "MANAGER") {
          // 운영자로 지정
          for (let i = 0; i < checkUsers.length; i++) {
            if (!checkUsers[i].isInternalUser) {
              const modalInfo = {
                title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                width: "400px",
                // height: "166px",
                obj: this.$modal,
                contents:
                  this.$i18nUtil.trans("message.ProjectMemberManage.009","그룹사, 외부 협력사 직원은 운영자로 지정할 수 없습니다."),
                button: this.$i18nUtil.trans("button.confirm","확인"),
                component: Dialog,
              };
              this.showModal(modalInfo);
              this.checkUsers = [];
              return;
            }
            const data = {
              userGrade: "MANAGER",
              userId: checkUsers[i].userId,
              userKbn: checkUsers[i].userKbn,
              groupId: this.info.groupId,
              currentGrade: checkUsers[i].userGrade,
            };
            updateUserList.push(data);
          }
        } else {
          return;
        }
        let obj = this;

        const reqData = {
          url: "/api/cogroup/cogroupUser/setUserGrade",
          method: "post",
          req: {
            updateCogroupUserList: updateUserList,
          },
        };
        obj.showLoadingbar();
        obj
          .COWORK_REST_ACTION(reqData)
          .then((res) => {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB067", {
              userGradeName: type == "MEMBER" ? obj.$i18nUtil.trans("message.ProjectMemberManage.002.member","멤버") 
                : obj.$i18nUtil.trans("message.ProjectMemberManage.002.manager","운영자"),
            });
            obj.showToast(this.toastInfo);

            obj.createdList();
            obj.searchReset();
            obj.hideLoadingbar();
          })
          .catch((err) => {
            console.log(err);
            console.log("[권한변경 오류]");
          });
      }
    },
    //회원 연장
    expireExtend(userId, userName) {
      this.createdList();
      let obj = this;
      setTimeout(() => {
        obj.projectMemberList.forEach((value) => {
          // console.log("#####", value);
          if (value.userId == userId) {
            if (!value.isExpire) {
              const modalInfo = {
                title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                width: "400px",
                // height: "166px",
                obj: this.$modal,
                contents: this.$i18nUtil.trans("AG063"),
                button: this.$i18nUtil.trans("button.confirm","확인"),
                component: Dialog,
              };
              obj.showModal(modalInfo);
            } else {
              const reqData = {
                url: "/api/auth/org/extensionExpDate",
                method: "post",
                req: {
                  userId: userId,
                },
              };

              obj
                .COWORK_REST_ACTION(reqData)
                .then((res) => {
                  if (res.errorCode) {
                    console.log(res.errorCode);
                  } else {
                    obj.toastInfo.message = obj.$i18nUtil.trans("message.ProjectMemberManage.010","{user}의 계정만료일이 연장되었습니다.", {user: userName});
                      // userName + "의 계정만료일이 연장되었습니다.";
                    obj.showToast(this.toastInfo);
                    obj.createdList();
                  }
                })
                .catch((err) => {
                  console.log(err);
                  console.log("[계정 만료기간 연장 오류]");
                });
            }
          }
        });
      }, 500);
    },
    handlerFilterMember(grade, searchType, searchKeyword, flag) {
      if (searchKeyword == "" && flag == 1) {
        this.toastInfo.message = this.$i18nUtil.trans("TB091");
        this.showToast(this.toastInfo);
        return;
      }
      if (flag == 1) {
        this.isFilter = true;
      }
      if (searchKeyword) {
        this.searchKeyword = searchKeyword;
      }
      this.cogroupUserList = [];
      this.projectMemberList.forEach((value) => {
        if (searchKeyword) {
          if (grade != "ALL_MEMBER") {
            if (searchType == "NAME") {
              if (
                value.userGrade == grade &&
                value.userName.indexOf(searchKeyword) != -1
              ) {
                this.cogroupUserList.push(value);
              }
            } else if (searchType == "ID") {
              if (
                value.userGrade == grade &&
                value.userId.indexOf(searchKeyword) != -1
              ) {
                this.cogroupUserList.push(value);
              }
            } else {
              if (
                value.userGrade == grade &&
                value.deptName.indexOf(searchKeyword) != -1
              ) {
                this.cogroupUserList.push(value);
              }
            }
          } else {
            if (searchType == "NAME") {
              if (value.userName.indexOf(searchKeyword) != -1) {
                this.cogroupUserList.push(value);
              }
            } else if (searchType == "ID") {
              if (value.userId.indexOf(searchKeyword) != -1) {
                this.cogroupUserList.push(value);
              }
            } else {
              if (value.deptName.indexOf(searchKeyword) != -1) {
                this.cogroupUserList.push(value);
              }
            }
          }
        } else {
          if (grade != "ALL_MEMBER") {
            if (value.userGrade == grade) {
              this.cogroupUserList.push(value);
            }
          } else {
            this.cogroupUserList.push(value);
          }
        }
      });
    },
    searchInput(e) {
      this.keyWord = event.target.value;
    },
    searchReset() {
      this.isFilter = false;
      this.searchKeyword = "";
      this.filter = "ALL_MEMBER";
      this.keyWord = "";
      this.cogroupUserList = this.projectMemberList;
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.krs028 .btm > .fl > span + .dropdown.enCss {
  left: 125px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ProjectMemberManage.vue